const angular = require('angular');
const uiRouter = require('angular-ui-router');
import routing from './main.routes';
import {Ids as ACTION_IDS} from '../../components/constants/action.constants'

export class MainController {

	pagedItems: any;
	totalItems: number;
	currentPage: number;
	recordSize: number;
	pageNo: number;
	maxSize: number;
	$http: any;
	$uibModal: any;
	currentData: any;
	selectedAll: boolean;
	searchVal: any;
	oldSearchVal: any;
	$state: any;
	$window: any;
	unauthorized: boolean;
	validListMessage: any;
	showSpinner: boolean;
	unauthorizedMessage: any;
	isPagedChange: boolean; // Page is changed then use.
	$scope: any;
	Util: any;
	config: any;
	ngNotification: any;

	/*@ngInject*/
	constructor($http, $scope, $uibModal, $state, $window, Util, config, Notification) {
		let self = this;
		this.config = config;
		this.Util = Util;
		this.$scope = $scope;
		this.unauthorized = false;
		this.unauthorizedMessage = "";
		this.showSpinner = true;
		this.validListMessage = "";
		this.$state = $state;
		this.$uibModal = $uibModal;
		this.$http = $http;
		this.$window = $window;
		this.totalItems = 0;
		this.pageNo = 0;
		this.recordSize = 10;
		this.maxSize = 8;
		this.currentPage = 1;
		this.pagedItems = [];
		this.oldSearchVal = "";
		this.isPagedChange = false;
		this.ngNotification = Notification;
		let initalized;
		if(config.showListing == true){
			initalized = Promise.all([Util.initServerCalls(), this.listingAjaxCall({ "page": 0, "size": 10, "sortColumn": "formName", "sortType": "ASC" })]);
		} else {
			if(config.initServerCalls == true){
				initalized = Util.initServerCalls(config);
			} else {
				initalized = Promise.all([]);
			}
		}
		initalized.then(function () {
			Util.setsessionTimoutTimer();
			self.showSpinner = false;
			self.$scope.$digest();
			if(config.showListing == false){
				self.$state.go('create', {
					params: {
						id: config.formDetail.id,
						formName: config.formDetail.formName,
						description: config.formDetail.description
					}
				});
			}
		}, function () {
			self.showSpinner = false;
		});
		(<any>window).onbeforeunload = function () {
			return null;
		};
	}

	/* Get listing data*/
	listingAjaxCall(data) {
		let self = this;
		self.validListMessage = "";
		return new Promise(function (resolve, reject) {
			self.$http({
				'url': (<any>window).properties.service.uri + ACTION_IDS.SEARCH_TEMPLATE,
				'method': 'POST',
				'data': data,
				'headers': {
					'Content-Type': 'application/json;charset=UTF-8'
				},
				'withCredentials': true
			}).then(response => {
				self.successCallback(response.data);
				resolve();
			}, function errorCallback(response) {
				switch(response.status){
					case 401:
						self.unauthorized = true;
						self.unauthorizedMessage = "Unauthorized access";
						break;
					case 503:
						self.validListMessage = "Service Temporary unavailable";
						break;
					case 500:
						self.validListMessage = "Internal Server Error";	
						break;
					case -1:
						self.unauthorized = true;
						self.unauthorizedMessage = "Connectivity Issue";
						break;
				}
				reject();
			});
		});
	}

    /* Success callback of the listing data */
    successCallback(data) {
    	let self = this;
		self.pagedItems = data.entity.records;
		self.totalItems = data.entity.totalRecords;
		self.pageNo = data.entity.page + 1;
		self.recordSize = data.entity.size;
		self.maxSize = 8;
		self.currentPage = self.currentPage;
		if(self.pagedItems.length == 0){
			self.validListMessage = "No Data Available.";
		}	
	}

	/* openModal create template modal */
	openModal(editTemplate) {

		var that = this;
		var modalInstance = this.$uibModal.open({
			animation: true,
			ariaLabelledBy: 'modal-title',
			ariaDescribedBy: 'modal-body',
			templateUrl: 'myModalContent.html',
			backdrop: 'static',
			keyboard: false,
			controllerAs: '$ctrl',
			controller: function () {
				this.msg = '';
				this.edit = editTemplate;
				this.inputName = that.currentData && that.currentData.formName;
				this.inputDesc = that.currentData && that.currentData.description;
				this.inputChk = true;
				this.showTemplateSpinner = false;
				this.restrictChar = function($event){
						this.msg = '';
  						var value  = $event.target.value;	
						if(value == ""){
							this.msg = "Template Name is required."
						} else {
							if (value.match(/[|<>\\/:?*"'$#]/gi)) {                
				                this.msg ='Template Name cannot contain any of the following characters: # \\ / : * ? " < > | $ \' ';
					            $event.preventDefault();
					            return false;  
	        				}
						}
						
				}
				this.ok = function () {
					var self = this;
					var data;
					self.showTemplateSpinner = true;
					if (that.currentData) {
						data = {
							"id": that.currentData.id,
							"description": this.inputDesc,
							"formName": this.inputName
						};
					} else {
						data = {
							"description": this.inputDesc,
							"formName": this.inputName
						};
					}

					that.$http({
						'url':  (<any>window).properties.service.uri + ACTION_IDS.CREATE_TEMPLATE,
						'method': 'POST',
						'data': data,
						'headers': {
							'Content-Type': 'application/json;charset=UTF-8'
						},
						'withCredentials': true
					}).then(response => {
						self.showTemplateSpinner = false;
						// modalInstance.dismiss('cancel');
						modalInstance.close(false);
						if (this.inputChk) {
							that.$state.go('create', {
								params: response.data.entity
							});
						} else {
							this.currentPage = 1;
							that.listingAjaxCall({ "page": 0, "size": 10, "sortColumn": "formName", "sortType": "ASC" });
						}
					}, function errorCallback(response) {
						self.showTemplateSpinner = false;
						self.msg = response.data && response.data.message;						
						self.inputName = "";
					});
				};

				this.cancel = function () {
					// modalInstance.dismiss('cancel');
					modalInstance.close(false);
				};
			}
		});

		modalInstance.result.then(function (selectedItem) {

		}, function () {

		});
	}

	// open template Modal
	openTemplate() {
		this.currentData = "";
		this.openModal(false);
	}

	// Edit selected Template
	editTemplate(items) {
		this.currentData = items;

		this.openModal(true);
	}

	// create design template
	designTemplate(items) {
		this.$state.go('create', {
			params: items
		});
	}

	// Download zip file
	downloadZip(data): void {
		if (data.formName.match(/[|<>\\/:?*"'$#]/gi)) {                
			this.ngNotification.error({ message: 'Template Name cannot contain any of the following characters: # \\ / : * ? " < > | $ \' ', positionX: 'center', replaceMessage: true });
			return;  
		}

		let timeStamp = new Date().getTime();
		let apidata = {
			"id": data.id,
			"name": data.formName,
			"timeStamp": timeStamp
		};
		let downloadURL = 'download';
		this.Util.downloadZip(downloadURL, apidata);
	}

	// Delete selected Template
	deleteTemplate(id) {
		var x = confirm("Are you sure you want to delete?");
		if (x) {
			this.$http({
				'url': (<any>window).properties.service.uri + ACTION_IDS.DELETE_TEMPLATE,
				'method': 'POST',
				'data': id,
				'headers': {
					'Content-Type': 'application/json;charset=UTF-8'
				},
				'withCredentials': true
			}).then(response => {
				this.listingAjaxCall({ "page": 0, "size": 10, "sortColumn": "formName", "sortType": "ASC" });
			});
		} else {
			return false;
		}
	}

	// Delete multiple  selected template
	multipleDeleteTemplate() {
		if(this.pagedItems.length > 0){
			var jsonData = [];
			angular.forEach(this.pagedItems, function (item) {
				if (item.selected) {
					jsonData.push(item.id);
				}
			});
			jsonData.length > 0 && this.deleteTemplate(jsonData);
		}		
	}

	// search template criteria	
	searchTempKeyEvent(keyEvent: any) {
		if (keyEvent && keyEvent.which == 13) {
			this.searchTemplate();
        }
	}

	// Search template value
	searchTemplate() {
		var searchVal = this.searchVal;
		var currentPageNo  =  this.isPagedChange ? this.currentPage - 1 : 0;
		if ((searchVal != this.oldSearchVal) || this.isPagedChange) {
			var data = {
				"page": currentPageNo,
				"size": 10,
				"sortColumn": "formName",
				"sortType": "ASC",
				"filters": [{
					"column": "formName",
					"operator": "CONTAIN",
					"values": [searchVal]
				}, {
						"column": "description",
						"operator": "CONTAIN",
						"values": [searchVal]
					}],
			};

			this.oldSearchVal = searchVal;			
			this.listingAjaxCall(data);
			if(this.isPagedChange == false){
				this.currentPage = 1;
			}	
			this.isPagedChange = false;		
		}
	}

	// change the page then call this
	pageChanged() {
		this.isPagedChange = true;
		this.searchTemplate();		
	}
	// click on row - selected checkbox is chcked or not
	rowClicked(item) {
		item.selected = item.selected ? false : true;
	}

	// Check and Uncheck checkboxx
	checkAll() {
		var isSelected;
		this.selectedAll = this.selectedAll ? true : false;
		isSelected = this.selectedAll;
		angular.forEach(this.pagedItems, function (item) {
			item.selected = isSelected;
		});
	   }
};

export default angular.module('nodeApp.main', [
	uiRouter])
    .config(routing)
    .component('main', {
		template: require('./main.html'),
		controller: MainController
    })
    .name;



// WEBPACK FOOTER //
// ./client/app/main/main.component.ts